import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { PackageSearch, FileText, FileSignature, ArrowRight } from "lucide-react";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const PortalHome = () => {
  const [summary, setSummary] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/portal/records-summary`, { withCredentials: true })
      .then((res) => setSummary(res.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const cards = [
    { title: "Purchase Orders", to: "/portal/orders", icon: PackageSearch, data: summary?.pos },
    { title: "Invoices", to: "/portal/invoices", icon: FileText, data: summary?.invoices },
    { title: "Quotations", to: "/portal/quotations", icon: FileSignature, data: summary?.quotations },
  ];

  const anyMatched = summary && (summary.pos?.matched || summary.invoices?.matched || summary.quotations?.matched);

  return (
    <div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-4">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.06}>
            <GlassCard tilt className="p-6 h-full flex flex-col">
              <span className="w-11 h-11 rounded-lg bg-qcyan/10 border border-qcyan/25 flex items-center justify-center mb-4">
                <c.icon size={20} className="text-qcyan" />
              </span>
              <div className="font-display font-bold text-3xl glow-text-cyan mb-1">
                {loaded ? (c.data?.count ?? 0) : "-"}
              </div>
              <p className="text-xs text-muted-foreground uppercase tracking-wide mb-4">
                {loaded ? "records linked to your email" : "loading..."}
              </p>
              <Link
                to={c.to}
                className="mt-auto inline-flex items-center gap-2 text-sm text-qcyan font-semibold hover:gap-3 transition-all"
              >
                View {c.title} <ArrowRight size={14} />
              </Link>
            </GlassCard>
          </Reveal>
        ))}
      </div>
      {loaded && !anyMatched && (
        <p className="text-sm text-muted-foreground mt-6">
          No records are currently linked to this email. Please contact admin.
        </p>
      )}
    </div>
  );
};

export default PortalHome;
